import { render } from "./SalesPersonCreateProfile.vue?vue&type=template&id=4f98c919&scoped=true&ts=true&lang=pug"
import script from "./SalesPersonCreateProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./SalesPersonCreateProfile.vue?vue&type=script&lang=ts&setup=true"

import "./SalesPersonCreateProfile.vue?vue&type=style&index=0&id=4f98c919&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f98c919"]])

export default __exports__